"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resources = void 0;
var _sceneLayoutFeaturedMedia = _interopRequireDefault(require("./images/scene-layout-featured-media.png"));
var _sceneLayoutFeaturedPresenter = _interopRequireDefault(require("./images/scene-layout-featured-presenter.png"));
var _sceneLayoutFeaturedScreen = _interopRequireDefault(require("./images/scene-layout-featured-screen.png"));
var _sceneLayoutGrid = _interopRequireDefault(require("./images/scene-layout-grid.png"));
var _sceneLayoutSideBySide = _interopRequireDefault(require("./images/scene-layout-side-by-side.png"));
var _sceneLayoutSingle = _interopRequireDefault(require("./images/scene-layout-single.png"));
var resources = exports.resources = {
  sceneLayoutFeaturedMedia: _sceneLayoutFeaturedMedia["default"],
  sceneLayoutFeaturedPresenter: _sceneLayoutFeaturedPresenter["default"],
  sceneLayoutFeaturedScreen: _sceneLayoutFeaturedScreen["default"],
  sceneLayoutGrid: _sceneLayoutGrid["default"],
  sceneLayoutSideBySide: _sceneLayoutSideBySide["default"],
  sceneLayoutSingle: _sceneLayoutSingle["default"]
};